<template>
    <div class="animated fadeIn orderDetailScreen bgV2" v-bind:class="{'run-loading':Loadings.detail && !loadings.stop}">
        <b-row v-if="Item">
            <b-col md="12">
                <div class="templateV2">
                    <div class="d-flex headerOrderDetail">
                        <div class="orderNumber">
                            <h1 class="m-0 p-0 orderTitle">{{Item.order_number}}</h1>
                            <h4 class="mb-15 p-0">{{Item.service_category ? Item.service_category.name : null}}</h4>
                        </div>
                        <div class="timeline mt-5">
                            <div class="inner" :class="lineProcess">
                                <div id="reported" class="item" v-bind:class="{'active': activeProcess >= 1}"><span v-b-tooltip.hover :title="Order && Order.kpi ? formatDate(Order.kpi.case_reported) : ''"></span>Reported</div>
                                <div id="acknowledged" class="item" v-bind:class="{'active': activeProcess >= 2}"><span v-b-tooltip.hover :title="Item && Item.kpi && Item.kpi.case_ack_actual ? formatDate(Item.kpi.case_ack_actual) : ''"></span>acknowledged</div>
                                <div id="wo-issued" class="item" v-bind:class="{'active': activeProcess >= 3}"><span v-b-tooltip.hover :title="Item && Item.created_at ? formatDate(Item.created_at) : ''"></span>WO Issued</div>
                                <div id="on-site" class="item" v-bind:class="{'active': activeProcess >= 4}"><span v-b-tooltip.hover :title="Item && Item.kpi && Item.kpi.case_onsite_actual ? formatDate(Item.kpi.case_onsite_actual) : ''"></span>On-Site</div>
                                <div id="wo-completed" class="item" v-bind:class="{'active': activeProcess >= 5}"><span v-b-tooltip.hover :title="Item && Item.kpi && Item.kpi.wo_complete_actual ? formatDate(Item.kpi.wo_complete_actual) : ''"></span>WO Completed</div>
                                <div id="ip-invoice" class="item" v-bind:class="{'active': activeProcess >= 6}"><span v-b-tooltip.hover :title="Item && Item.kpi && Item.kpi.admin_start_actual ? formatDate(Item.kpi.admin_start_actual) : ''"></span>AP Invoice</div>
                                <div id="payment-made" class="item" v-bind:class="{'active': activeProcess >= 7}"><span v-b-tooltip.hover :title="Item && Item.kpi && Item.kpi.admin_closure_actual ? formatDate(Item.kpi.admin_closure_actual) : ''"></span>Payment</div>
                            </div>
                        </div>
                        <div class="orderStatus text-right">
                            <h4 class="mt-5 c-orange f-uppercase">{{Item.order_status && Item? Item.order_status : ''}} <span v-if="Item && (Item.order_status === 'Under Approval' || Item.order_status === 'Pending Revision') && ApprovalLogs.total">({{ApprovalLogs.total}})</span></h4>
                            <div class="mt-3 d-flex justify-content-end">
                                <template v-if="!IsReadOnly">
                                    <gofix-button
                                        v-if="Item.order_status !== 'Closed' && $checkRole($accessModule.work_order_to_paid, 'wo_to_paid')"
                                        @click="changeOrderStatus('Closed')"
                                        class="ml-3" label="Paid"
                                        outline>
                                    </gofix-button>
                                </template>
                                <b-button
                                    v-if="Item.order_status && ['Approved', 'Dispatched', 'Acknowledged', 'On-Site', 'Pending-Parts', 'Partially Completed', 'Completed', 'Invoiced'].includes(Item.order_status)"
                                    @click="printWoPDF" 
                                    class="goFixPrintButton ml-3" 
                                    title="Print" 
                                    v-b-tooltip.hover>
                                        <i class="icon-printer icons"></i>
                                </b-button>
                                <template v-if="!IsReadOnly">
                                    <gofix-button
                                            v-b-tooltip.hover
                                            :title=" approverCurrent.user && Item.order_status === 'Under Approval' ? 'To be approved by: ' + approverCurrent.user : ''"
                                            v-if="(ApprovalLogs && ApprovalLogs.total && Item.order_status !== 'Issued') || (Item.order_status === 'Under Approval')"
                                            :label="(Item.order_status === 'Under Approval' || Item.order_status === 'Pending Revision') ? 'APPROVAL' : 'APPROVAL LOG'"
                                            class="ml-3"
                                            @click="openModalApproval" outline></gofix-button>
                                    <gofix-button
                                            v-b-tooltip.hover
                                            :title="approverCurrent.user && Item.order_status === 'Under Approval' ? 'To be approved by: ' + approverCurrent.user : ''"
                                            v-if="Item.order_status !== 'Under Approval' && Item.order_status !== 'Pending Revision'"
                                            class="ml-3" label="NEXT ACTION"
                                            @click="modals.status = true" outline>
                                    </gofix-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col md="12">
                <gofix-tab
                        class="orderTab"
                        :data="order_tab_role"
                        :query-param="{id:$route.params.id}"
                        activeKey="main_info"
                        arrows >
                    <template slot="gofixTab:main_info">
                        <tab-main-info ref="maininfo" @reloadorder="reloadOrder" @orderNeedApproval="updateOrderNeedApproval"></tab-main-info>
                    </template>
                    <template slot="gofixTab:kpi_target">
                        <kpiTarget></kpiTarget>
                    </template>
                    <template slot="gofixTab:service_report">
                        <serviceReport @reloadorder="reloadOrder"></serviceReport>
                    </template>
                    <template slot="gofixTab:related_work_items">
                        <relatedWorkItems></relatedWorkItems>
                    </template>
                    <template slot="gofixTab:delivery_log">
                        <deliveryOrder @reloadorder="reloadOrder" ref="deliveryOrder"></deliveryOrder>
                    </template>
                    <template slot="gofixTab:budget">
                        <budget></budget>
                    </template>
                    <template slot="gofixTab:activity_log">
                        <wo-activities ref="woActivities" class="custom-wo-activity" activityType="Work Order" :activityId="$route.params.id" :controls="controls" nameTable="order-activity-log"></wo-activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal
            :no-close-on-backdrop="true"
            id="modal-order-approval-log"
            modal-class="modals-approval gofixModal"
            size="lg"
            title="Approval"
            hide-footer
            :centered="true"
            ref="modal-approval-log"
            v-model="modals.approval_log"
            @hidden="approvalLogObj.remark = null">
            <!-- Action & Remarks -->
            <div class="actionAndRemarks modalPadding" v-bind:class="{'disabled-block':!approvalData.approval && orderNextStatus !== 'Under Approval' && (Item && Item.current_approval_level != null && Item.current_approval_level >= 0 )}">
                <b-row>
                    <b-col md="12" class="mb-3" v-if="Item && (Item.order_status === 'Under Approval' || Item.order_status === 'Issued' || Item.order_status === 'Pending Revision')">
                        <gofix-text-field label="Next Approver" oneline>
                            <span class="pl-20" v-if="approvalData.limit && checkInRoleApproval()">--</span>
                            <span class="pl-20" v-else>{{approverNext.limit| formatMoney}} - {{approverNext.user}}</span>
                        </gofix-text-field>
                    </b-col>
                    <b-col md="12" class="mb-3" v-if="Item && (Item.order_status === 'Under Approval' || Item.order_status === 'Issued' || Item.order_status === 'Pending Revision')">
                        <gofix-text-field label="Current Approver" oneline>
                            <span v-if="Item && Item.order_status === 'Issued'">--</span>
                            <span v-else>{{approverCurrent.limit| formatMoney}} - {{approverCurrent.user ? approverCurrent.user : ''}}</span>
                        </gofix-text-field>
                    </b-col>
                    <b-col md="9" class="">
                        <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="approvalLogObj.remark" />
                    </b-col>
                    <b-col md="3" class="action">
                        <gofix-button
                            class="d-block mb-2 w-100"
                            :label="Item && Item.order_status === 'Pending Revision' ? 'Revision Applied' : (Item && Item.order_status === 'Issued' ? 'Request for Approval' : 'Recommend for Approval')"
                            @click="approvalLog('Recommend for Approval')"
                            v-if="!approvalData.limit"
                            :disabled="(!approvalData.approval && orderNextStatus !== 'Under Approval' && Item &&  Item.current_approval_level !== null && Item.current_approval_level >= 0 ) || loadings.logs"
                            outline />
                        <gofix-button
                            class="d-block mb-2 w-100"
                            label="Approve"
                            @click="approvalLog('Approval')"
                            v-if="approvalData.limit"
                            :disabled="!approvalData.approval || loadings.logs"
                            outline />
                        <gofix-button
                            class="d-block mb-2 w-100"
                            label="Request for Revision"
                            @click="approvalLog('Request for Revision')"
                            v-if="(Item && Item.current_approval_level >= 0 && Item.current_approval_level !== null)"
                            :disabled="!approvalData.approval || loadings.logs"
                            outline />
                        <gofix-button
                            v-if="Item && approvalData.approval"
                            class="d-block w-100"
                            label="Reject"
                            @click="approvalLog('Reject')"
                            :disabled="(!approvalData.approval && orderNextStatus !== 'Under Approval') || loadings.logs"
                            outline dark />
                        <gofix-button
                            v-if="Item && (Item.order_status === 'Issued' || Item.order_status === 'Pending Revision') && !approvalData.approval"
                            :disabled="!approvalData.approval && orderNextStatus !== 'Under Approval' && (Item && Item.current_approval_level != null && Item.current_approval_level >= 0 )"
                            class="d-block w-100"
                            label="Cancel"
                            @click="modals.approval_log = false"
                            outline dark />
                    </b-col>
                </b-row>
            </div>
            <hr/>
            <b-row>
                <b-col md="12" class="mb-3">
                    <h5 class="modalTitle modalPadding">Approval Log</h5>
                </b-col>
                <b-col md="12">
                    <div class="gofixBasicTable approvalLogTable">
                        <div class="dataList">
                            <vue-scrollbar class="tableList">
                                <b-table :fields="fields" :items="ApprovalLogs.data" class="table-has-fixed" fixed>
                                    <template slot="finance_limit" slot-scope="row">
                                        {{ row.item.finance_limit | formatMoney}}
                                    </template>
                                    <template slot="log_time" slot-scope="row">
                                        {{ row.item.log_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                                    </template>
                                </b-table>
                            </vue-scrollbar>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" size="lg" title="Actions" hide-footer :centered="true" @show="orderNextStatus = null" ref="modal-approval-log" v-model="modals.status">
            <b-row>
                <b-col>
                    <b-form class="formV2" v-bind:class="{'run-loading':loadings.status}">
                        <gofix-form-dropdown
                            label="Next Available Actions"
                            vLabel="label"
                            v-model="orderNextStatus"
                            required
                            :reduce="option => option.value"
                            :options="orderNextStatusData" />
                        <gofix-form-dropdown
                            v-if="orderNextStatus === 'Cancelled'"
                            label="reasons for cancellation"
                            vLabel="reference_value_text"
                            v-model="orderCancelData.reason_id"
                            required
                            :reduce="option => option.id"
                            :options="reasonsForCancellation" />
                        <gofix-form-input-textarea
                            v-if="orderNextStatus === 'Cancelled'"
                            label="remark"
                            class="h-100"
                            v-model="orderCancelData.remark" />
                        <gofix-attachment-area v-if="orderNextStatus === 'Cancelled'" v-model="orderCancelData.files" multiple />
                        <b-button-group class="d-block text-right">
                            <gofix-button label="SUBMIT" @click="changeOrderStatus('')" noBorder />
                        </b-button-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm_raise_cod">
            <div class="center">Do you want to raise COD <strong>work order</strong>?<br/> Add <strong>ME</strong> and <strong>PV</strong> will be generated!</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.confirm_raise_cod = false">No</b-button>
                <b-button class="custom-btn" @click="changeOrderStatus('')"> Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    const mainInfo = () => import('./tab-main-info')
    const kpiTarget = () => import('./tab-kpi-target')
    const serviceReport = () => import('./tab-service-report')
    const relatedWorkItems = () => import('./tab-related-work-item')
    const deliveryOrder = () => import('./tab-delivery-order')
    const budget = () => import('./tab-budget')
    const woActivities = () => import("../global/Activities")
    import moment from 'moment';
    export default {
        name: 'work-order',
        components: {
            "tab-main-info":mainInfo,
            kpiTarget,
            serviceReport,
            relatedWorkItems,
            deliveryOrder,
            budget,
            woActivities
        },
        data () {
            return {
                order_tab:tabData.order,
                activeProcess:3,
                tabIndex: 0,
                id:null,
                modals: {
                    approval_log: false,
                    status: false,
                    confirm_raise_cod: false,
                },
                approvalData:{
                    current:null,
                    limit:false,
                    approval: false
                },
                approvalLogObj:{
                    order_id : this.$route.params.id,
                    approval_id: null,
                    action:null,
                    remark:null,
                    approval: false,
                    reject: false,
                },
                fields:[
                    {
                        key: 'approval_route_level',
                        label: 'Level',
                        thStyle: 'width: auto'
                    },
                    {
                        key: 'finance_limit',
                        label: 'Approval Limit',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'reviewer.name',
                        label: 'Reviewer',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'log_time',
                        label: 'Date Time',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'action',
                        thStyle: 'width: 170px',
                        label: 'Action',
                    },
                    {
                        key: 'remark',
                        thStyle: 'width: 170px',
                        label: 'Remarks',
                    },
                ],
                loadings : {
                    logs: false,
                    status: false,
                    stop:false
                },
                hideApproval:false,
                staffs : [],
                statusData:{
                    "Issued" : [
                        {
                            value: "Completed",
                            label: "Complete WO"
                        },
                        {
                            value: "Under Approval",
                            label: "Request for Approval"
                        },
                        {
                            value: "COD Raised",
                            label: "Raise COD"
                        }
                    ],
                    "Under Approval" : [
                        {
                            value: "Approved",
                            label: "Approval"
                        },
                        {
                            value: "Rejected",
                            label: "Reject"
                        },
                    ],
                    "Approved" : [
                        {
                            value: "Dispatched",
                            label: "Dispatched"
                        },
                    ],
                    "Dispatched" : [
                        {
                            value: "Acknowledged",
                            label: "Acknowledged"
                        },
                    ],
                    "Acknowledged" : [
                        {
                            value: "On-Site",
                            label: "On-Site"
                        },
                    ],
                    "On-Site" : [
                        {
                            value: "Completed",
                            label: "Full Delivery"
                        },
                        {
                            value: "Pending-Parts",
                            label: "Pending Parts"
                        },
                        {
                            value: "Partially Completed",
                            label: "Partial Delivery"
                        },
                    ],
                    "Pending-Parts" : [
                        {
                            value: "On-Site",
                            label: "Pending Parts Available"
                        },
                    ],
                    "Partially Completed" : [
                        {
                            value: "Invoiced",
                            label: "AP Invoice Received"
                        },
                    ],
                    "Completed" : [
                        {
                            value: "Invoiced",
                            label: "AP Invoice Received"
                        }
                    ],
                    "Invoiced" : [
                        {
                            value: "Closed",
                            label: "Paid"
                        },
                    ],
                    "COD Raised": [
                        {
                            value: "Closed",
                            label: "Close COD WO"
                        },
                    ]
                },
                orderNextStatus : null,
                orderCancelData:{
                    order_id: this.$route.params.id,
                    reason_id: null,
                    remark: null,
                    files: []
                },
                reasonsForCancellation:[],
                approverNext: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                approverCurrent: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                controls: {
                    create: false,
                    delete: false,
                    update: this.$checkRole(this.$accessModule.order_tabs.activity_log, 'update')
                },
                isLMUShowStatusApproval: false,
            }
        },
        async created(){
            if(!this.$route.params.hasOwnProperty('id')) {
                return this.$router.push(`/v2/orders`);
            }
            this.id = this.$route.params.id;
            this.$store.dispatch("OrderController/getItem",this.id)
                .then(data => {
                    //GET Service categories with contract id
                    this.$store.dispatch("OrderController/getServiceCategories",this.Item.contract_id);

                    if(data.order_status === 'Under Approval' || data.order_status === 'Issued'){
                        this.getNextApprover();
                    }
                })
                .catch(err=>{
                    return this.$router.push(`/v2/orders`);
                });
            this.loadings.logs = true;
            this.$store.dispatch("OrderApprovalLogController/getItems",{
                page:1,
                limit:-1,
                filter:{
                    order_id: this.id
                }
            })
                .then( data => {
                    this.loadings.logs = false;
                })
                .catch(err => {
                    this.loadings.logs = false;
                })
            if(this.$route.path.includes('kpi-target') || this.$route.path.includes('service-report') || this.$route.path.includes('related-work-items') || this.$route.path.includes('budget') || this.$route.path.includes('activity-log')) {
                return this.$router.push(`/v2/orders/${this.$route.params.id}`);
            }
            this.getApprovalLogTableSetting();
            this.getReasonForCancellation();
            await this.$store.commit("OrderController/setIsReadOnly", this.$checkRole(this.$accessModule.wo_the_read_only, 'wo_the_read_only'));
            if(this.IsReadOnly) this.controls.update = false
        },
        watch: {
            "Item": function(val){
                if(val) {
                    //this.checkApprovalAccess(val);
                    this.getReasonForCancellation();
                }
                
                // callback Contract selector
                if(val && val.contract_id && (!this.clientContractID || !this.clientContractID.id || (this.clientContractID && this.clientContractID.id && this.clientContractID.id != val.contract_id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', val.contract_id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }
            },
            tabIndex: function(val) {
                if(val === 6) {
                    this.$refs.woActivities.triggerReloadData();
                }
                if(val === 4) {
                    this.$refs.deliveryOrder.reloadData();
                }
            }
        },
        computed: {
            orderNextStatusData(){
                /*--- LMU project ---*/
                if(!this.Item || !this.Item.order_status) return [];
                if(this.Item.supplier_contract && this.Item.supplier_contract.hasOwnProperty('is_supplier_under_lmu_project') && this.Item.supplier_contract.is_supplier_under_lmu_project) {
                    let status = [];
                    if(this.Item.order_status == 'Issued') {
                        let statusNext = [
                            {
                                value: "Under Approval",
                                label: "Request for Approval"
                            }
                        ];
                        if((this.Item.supplier_contract.lmu_settings.hasOwnProperty('is_non_chargeable') && this.Item.supplier_contract.lmu_settings.is_non_chargeable) || !this.isLMUShowStatusApproval) {
                            statusNext = [{
                                value: "Completed",
                                label: "Complete WO"
                            }];
                        }
                        this.statusData[this.Item.order_status] = statusNext;
                    }
                    if(this.statusData[this.Item.order_status])
                        status = [].concat(this.statusData[this.Item.order_status]);
                    return status;
                }

                if((this.Item.order_status == 'Completed' || 
                    this.Item.order_status == 'Partially Completed') && 
                    !this.$checkRole(this.$accessModule.allow_wo_invoiced, 'allow_wo_invoiced')){
                    return [];
                }
                if(this.Item.order_status == 'Issued'){
					if((this.Item.client_contract.settings && !this.Item.client_contract.settings.is_allow_wo_issued_to_completed) || !this.Item.client_contract.settings){
						let statusNext = [{
                            value: "Under Approval",
                            label: "Request for Approval"
                        },
                        {
                            value: "COD Raised",
                            label: "Raise COD"
                        }];
						this.statusData[this.Item.order_status] = statusNext;
					}
				}
                let status = [];
                if(this.statusData[this.Item.order_status])
                    status = [].concat(this.statusData[this.Item.order_status]);
                let statusHasCancel = ["Partially Completed", "Pending-Parts", "On-Site", "Dispatched", "Acknowledged" ,"Approved", "Under Approval", "Issued"];
                if(statusHasCancel.indexOf(this.Item.order_status) >= 0){
                    //check is FM in charge
                    if(this.Item.officer_in_charge_id === this.User.id){
                        status.push({
                            value: "Cancelled",
                            label: "Cancel"
                        });
                    }else{
                        if(this.checkInTeam()){
                            status.push({
                                value: "Cancelled",
                                label: "Cancel"
                            });
                        }
                    }
                }
                return status;
            },
            lineProcess(){
                let process = "node-3";
                if(this.Item && this.Item.order_status) {
                    switch (this.Item.order_status) {
                        case "On-Site":
                            process = "node-4";
                            this.activeProcess = 4;
                            break;
                        case "Partially Completed":
                        case "Completed":
                            process = "node-5";
                            this.activeProcess = 5;
                            break;
                        case "Invoiced":
                            process = "node-6";
                            this.activeProcess = 6;
                            break;
                        case "Closed":
                            process = "node-7";
                            this.activeProcess = 7;
                            break;
                        default:
                            process = "node-3";
                            this.activeProcess = 3;
                            break;
                    }
                }
                return process;
            },
            order_tab_role(){
                let tabs = tabData.order;
                for(let i = 0; i < tabs.length; i++){
                    tabs[i].disabled = !this.$checkRole(this.$accessModule.order_tabs[tabs[i].key], 'read')
                }
                return tabs;
            },
            isLMUProject() {
                if(!this.Item || !this.Item.supplier_contract) return false;
                return true;
            },
            ...mapGetters({
                Item: 'OrderController/Item',
                Loadings: 'OrderController/Loadings',
                ApprovalLogs: 'OrderApprovalLogController/Items',
                User : 'AuthController/user',
                Order: 'OrderController/Item',
                clientContractID: 'ContractController/ClientContractID',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
        },
        methods: {
            formatDate(value, type = "YYYY-MM-DD HH:mm:ss") {
                if(!value) return '';
                return moment(value, type).format('DD.MM.YYYY HH:mm');
            },
            approvalLog(action){
                if (!this.approvalData.approval && this.orderNextStatus !== "Under Approval" && this.Item && this.Item.current_approval_level !== null && this.Item.current_approval_level >= 0) return;
                if(this.loadings.logs) return;
                this.loadings.logs = true;
                let userRoles = this.User.roles.map(a => a.id);
                let currentRoles = this.approvalData && this.approvalData.current && this.approvalData.current.roles ? this.approvalData.current.roles.map(a => a.id) : [];
                let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                if(this.orderNextStatus === "Under Approval" && (!this.Item.approval_levels || !this.Item.approval_levels[0] || !arrTmp.length)){
                    this.$store.dispatch("OrderApprovalLogController/createItem",{
                        order_id : this.$route.params.id,
                        action: "Under Approval",
                        remark: this.approvalLogObj.remark,
                    })
                        .then(response => {
                            this.$alertNotification(this.$notificationV2('adding', 'approval'));
                            this.modals.approval_log = false;
                            this.Item.order_status = "Under Approval";
                            this.orderNextStatus = null;
                            this.reloadOrder();
                            this.getNextApprover();
                            this.$store.dispatch("OrderApprovalLogController/getItems",{
                                page:1,
                                limit:-1,
                                filter:{
                                    order_id: this.id
                                }
                            })
                            setTimeout(()=>{
                                this.loadings.logs = false;
                            },1000);
                        })
                        .catch( err => {
                            this.$alertNotification(`Can't "${action}"`, "warning");
                            setTimeout(()=>{
                                this.loadings.logs = false;
                            },1000);
                        })
                    return;
                }
                this.approvalLogObj.action = action;
                if(action === "Reject") this.approvalLogObj.reject = true;
                if(action === "Approval")this.approvalLogObj.approval = true;
                this.$store.dispatch("OrderApprovalLogController/createItem",this.approvalLogObj)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('adding', 'approval'));
                        this.modals.approval_log = false;
                        if(this.approvalLogObj.reject) this.Item.order_status = "Rejected";
                        if(this.approvalLogObj.approval) this.Item.order_status = "Approved";
                        this.reloadOrder();
                        this.getNextApprover();
                        this.orderNextStatus = null;
                        this.$store.dispatch("OrderApprovalLogController/getItems",{
                            page:1,
                            limit:-1,
                            filter:{
                                order_id: this.id
                            }
                        })
                        setTimeout(()=>{
                            this.loadings.logs = false;
                        },1000);
                    })
                    .catch( err => {
                        this.$alertNotification(`Can't "${action}"`, "warning");
                        setTimeout(()=>{
                            this.loadings.logs = false;
                        },1000);
                    })
            },
            changeOrderStatus(val){
                if(this.orderNextStatus === "Under Approval"){
                    this.openModalApproval();
                    this.modals.status = false;
                    return;
                }

                if(this.orderNextStatus === "COD Raised" && !this.modals.confirm_raise_cod){
                    if(!this.Item.get_order_line_item.length) {
                        return this.$alertNotification("Please add at least 1 line item.", "danger");
                    }
                    this.modals.status = false;
                    this.modals.confirm_raise_cod = true;
                    return;
                }

                if(this.Item.order_status == "Issued" && this.orderNextStatus === "Completed" && this.isLMUProject && !this.Item.get_order_line_item.length){
                    return this.$alertNotification("Please add at least 1 line item.", "danger");
                }

                if(this.Item.module_type.toLowerCase() == 'wsh' && this.orderNextStatus === "Completed" && this.Item.contractor_supervisor_id != this.User.id){
                    return this.$alertNotification("Only Contractor Supervisor can complete this work order.", "danger");
                }

                let data = {
                    status: val ? val : this.orderNextStatus,
                    id: this.$route.params.id,
                    order_cancel: this.orderNextStatus === "Cancelled" ? this.orderCancelData : null
                };
                if(data.order_cancel){
                    if(!this.orderCancelData.reason_id){
                        return this.$alertNotification("Please select a reason for cancellation", "danger");
                    }
                }
                this.loadings.status = true;
                this.$store.dispatch("OrderController/changeStatus",data)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('editing', 'order'));
                        this.Item.order_status = response.order_status;
                        this.loadings.status = false;
                        this.modals.status = false;
                        this.modals.confirm_raise_cod = false;
                        this.orderNextStatus = null;
                        this.reloadOrder();
                        if(this.$refs.maininfo){
                            this.$refs.maininfo.reloadOrderItem();
                        }
                    })
                    .catch(err => {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                        this.loadings.status = false;
                    })
            },
            reloadOrder(){
                this.loadings.stop = true;
                this.$store.dispatch("OrderController/getItem",this.id)
                    .then(data => {
                        //GET Service categories with contract id
                        this.$store.dispatch("OrderController/getServiceCategories",this.Item.contract_id);
                        this.loadings.stop = false;
                    })
                    .catch(err=>{
                        console.log(err);
                        this.loadings.stop = false;
                    });
            },
            openModalApproval(){
                if(this.Item.get_order_line_item.length){
                    //check limit again
                    this.getNextApprover();
                    this.checkApprovalAccess(this.Item)
                    this.modals.approval_log = true
                }else{
                    this.$alertNotification("Please add a order line item to approve", "warning");
                }
            },
            getNextApprover(){
                this.$store.dispatch("OrderApprovalLogController/getNextApprover",{
                    order_id: this.$route.params.id,
                })
                    .then(response => {
                        this.approverNext.user = response.next.user_name ? response.next.user_name.join(", ") : null;
                        this.approverNext.ids = response.next.user_ids;
                        this.approverNext.limit = response.next.finance;

                        this.approverCurrent.user = response.current.user_name ? response.current.user_name.join(", ") : null;
                        this.approverCurrent.ids = response.current.user_ids;
                        this.approverCurrent.limit = response.current.finance;
                    })
                    .catch( err => {
                        this.approverNext.user = null;
                        this.approverNext.ids = [];
                        this.approverNext.limit = null;

                        this.approverCurrent.user = null;
                        this.approverCurrent.ids = [];
                        this.approverCurrent.limit = null;
                    })
            },
            getApprovalLogTableSetting(){
                this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                    user_id: 0,
                    table_name: "work-order-approval-log"
                }).then(response => {
                    this.fields = response.data.data.settings.fields
                }).catch(error => {})
            },
            checkApprovalAccess(val){
                let key = (val.current_approval_level >= 0 && val.current_approval_level !== null) ? val.current_approval_level : 0;
                this.approvalData.current = this.Item.approval_levels[key] ? this.Item.approval_levels[key] : null;
                if(this.approvalData.current && (this.Item.order_status === "Under Approval" || (this.Item.order_status === "Pending Revision" && val.current_approval_level >= 0))){
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    if(this.approvalData.current && this.approvalData.current.finance_limit >= this.Item.total_net_amount){
                      if(this.Order.client_contract && this.Order.client_contract.settings && this.Order.client_contract.settings.is_exclude_1st_level_approver && this.Order.created_by === this.User.id){
                        this.approvalData.limit = false;
                      }else{
                        this.approvalData.limit = true;
                      }
                    }else{
                        this.approvalData.limit = false;
                    }
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                        this.approvalData.approval = true;
                        if(key == 0
                            && this.clientContractID
                            && this.clientContractID.settings
                            && this.clientContractID.settings.is_exclude_1st_level_approver
                            && this.approverCurrent.ids && !this.approverCurrent.ids.includes(this.User.id)
                            && this.User.id == this.Item.created_by) {
                                this.approvalData.approval = false;
                        }
                    }else{
                        this.approvalData.approval = false;
                    }
                }else if(this.approvalData.current && (this.orderNextStatus === "Under Approval" || (this.Item.order_status === "Pending Revision" && val.current_approval_level === -1))){
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                      this.approvalData.approval = true;
                      if(this.approvalData.current && this.approvalData.current.finance_limit >= this.Item.total_net_amount){
                          if(this.Order.client_contract && this.Order.client_contract.settings && this.Order.client_contract.settings.is_exclude_1st_level_approver && this.Order.created_by === this.User.id){
                            this.approvalData.limit = false;
                          }else{
                            this.approvalData.limit = true;
                          }
                        }else{
                            this.approvalData.limit = false;
                        }
                    }
                }else{
                    this.approvalData.approval = false;
                    this.approvalData.limit = false;
                }
            },
            checkInRoleApproval(){
                if(!this.approvalData.current || !this.approvalData.current.roles) return false;
                let userRoles = this.User.roles.map(a => a.id);
                let roles     = this.approvalData.current.roles.map(a => a.id);
                const arrTmp  = userRoles.filter(item => roles.includes(item));
                if(arrTmp.length){
                    return true;
                }
                return false
            },
            getReasonForCancellation(){
                this.$store.dispatch("ReferenceController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "reference_value_text",
                    sortDirection: "DESC",
                    isCMS:0,
                    filter:{
                        reference_type:"Reasons For Cancellation",
                        contract_id: this.Item ? this.Item.contract_id : 0
                    }
                })
                    .then(response => {
                        this.reasonsForCancellation = response.items;
                    })
                    .catch(err => {
                        this.reasonsForCancellation = [];
                    })
            },
            checkInTeam(){
                if (this.Item.team_in_charge_id) {
                    let checkUserLogin = false;
                    if (this.User.user_team && this.User.user_team.length) {
                        for (let i = 0; i < this.User.user_team.length; i++) {
                            if (this.User.user_team[i].group_id === this.Item.team_in_charge_id) {
                                checkUserLogin = true;
                            }
                        }
                    }
                    return checkUserLogin;
                } else {
                    return false;
                }
            },
            printWoPDF() {
                const namePDF = `${this.Item.order_number}.pdf`
                this.$store.dispatch(`OrderController/printWo`, this.$route.params.id)
                .then( response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', namePDF);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {});
            },
            updateOrderNeedApproval(val) {
                this.isLMUShowStatusApproval = val;
            }
        }
    }
</script>
